import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { requiredRule, urlRule } from '@utils/rules'
import { Form, Input } from 'antd'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item label={'Name'} name={'name'} rules={[requiredRule()]}>
        <Input />
      </Form.Item>
      <Form.Item
        label={'Venue Group ID'}
        name={'venueGroupId'}
        rules={[requiredRule()]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={'Manager base URL'}
        name={'managerBaseUrl'}
        rules={[requiredRule(), urlRule()]}
      >
        <Input />
      </Form.Item>
    </Form>
  )
}

export default Create
